import * as Yup from "yup";
import { Formik } from "formik";

import Text from "../../styleguide/Text";
import { fetchUserToken } from "../../redux/api/auth.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import TextInput from "../../components/misc/TextInput";
import ContentCard from "../../components/misc/ContentCard";
import CustomButton from "../../components/CustomButton";
import { toAbsoluteUrl } from "../../helpers/assetHelper";

const loginSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .required("Adaugati un nume de utilizator"),
  password: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .required("Adaugati o parola"),
});

const initialValues = {
  name: "",
  password: "",
};

const Login = () => {
  const dispatch = useAppDispatch();

  const {
    auth: { isLoadingToken, isErrorToken, errorMessageToken },
    user: { isLoadingUser, isErrorUser, errorMessageUser },
  } = useAppSelector((state) => ({
    auth: state.auth,
    user: state.user,
  }));

  const isLoading = isLoadingToken || isLoadingUser;
  const loginError = isErrorToken
    ? errorMessageToken || "Autentificarea a eșuat. Încearcă din nou."
    : isErrorUser
    ? errorMessageUser ||
      "Nu s-au putut încărca datele contului. Încearcă din nou."
    : undefined;

  const handleLogin = async (values: any) => {
    const userData = {
      userName: values.name,
      password: values.password,
    };
    await dispatch(fetchUserToken(userData));
  };

  return (
    <div className="flex h-full flex-col items-center justify-center px-3">
      <ContentCard
        className="w-full max-w-[460px] !px-8 !py-10"
        cardHeaderClassName="!pt-0"
        CardHeader={() => (
          <div className="mb-8 text-center">
            <img
              src={toAbsoluteUrl("/logo.svg")}
              alt="ATS TMS"
              width={120}
              height={85}
              className="mx-auto mb-4 block h-auto max-w-full"
            />
            <div className="mx-auto mb-5 h-1 w-12 rounded-full bg-[#2196f3]" />
            <Text variant="h1" component="h1" className="!mb-2">
              Autentificare
            </Text>
            <Text variant="body2" className="text-muted-dark">
              Intră în contul tău pentru a continua.
            </Text>
          </div>
        )}>
        <Formik
          initialValues={initialValues}
          validationSchema={loginSchema}
          onSubmit={handleLogin}>
          {({
            status,
            isValid,
            errors,
            touched,
            getFieldProps,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              aria-label="Autentificare"
              className="w-full"
              onSubmit={handleSubmit}
              noValidate
              id="kt_login_signin_form">
              <TextInput
                name="name"
                label="Utilizator"
                error={errors["name"]}
                touched={touched["name"]}
                inputProps={getFieldProps("name")}
              />
              <TextInput
                name="password"
                label="Parolă"
                type="password"
                error={errors["password"]}
                touched={touched["password"]}
                inputProps={getFieldProps("password")}
              />
              {!isLoading && (status || loginError) && (
                <div
                  role="alert"
                  className="mb-5 rounded-control bg-danger-subtle px-4 py-3 text-danger">
                  {status || loginError}
                </div>
              )}
              <CustomButton
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                className="w-full !min-h-[48px] !text-base"
                disabled={!isValid || isSubmitting || isLoading}
                loading={isLoading}>
                Continuă
              </CustomButton>
            </form>
          )}
        </Formik>
      </ContentCard>
    </div>
  );
};

export default Login;
